import { translateManager as t } from 'services/TranslateManager'
import { formatPrice } from 'utils/utils'
import SummaryItem from 'components/SummaryItem/SummaryItem'
import { TAX_TYPES } from '@mixtiles/web-backend-shared'

function TaxSummaryItem({ tax, taxName, currency }) {
  let countryTax
  if (taxName === TAX_TYPES.IMPORT_FEE) {
    countryTax = t.get('order.checkout.payment_summary_rows.import_fee')
  } else if (taxName === TAX_TYPES.SALES_TAX) {
    countryTax = t.get('order.checkout.payment_summary_rows.sales_tax')
  } else if (taxName === TAX_TYPES.INTERNATIONAL_TAXES) {
    countryTax = t.get(
      'order.checkout.payment_summary_rows.international_taxes'
    )
  }
  if (tax) {
    return (
      <SummaryItem
        text={
          countryTax ||
          taxName ||
          t.get('order.checkout.payment_summary_rows.tax')
        }
        testId="tax-summary-item"
      >
        {formatPrice(tax, currency)}
      </SummaryItem>
    )
  }
  return null
}

export default TaxSummaryItem
